import { Icon, IconProps } from "../";

export const PhoneIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M107.23,1303.26 L104.69,1302.97 C104.08,1302.9 103.48,1303.11 103.05,1303.54 L101.21,1305.38 C98.38,1303.94 96.06,1301.63 94.62,1298.79 L96.47,1296.94 C96.9,1296.51 97.11,1295.91 97.04,1295.3 L96.75,1292.78 C96.63,1291.77 95.78,1291.01 94.76,1291.01 L93.03,1291.01 C91.9,1291.01 90.96,1291.95 91.03,1293.08 C91.56,1301.62 98.39,1308.44 106.92,1308.97 C108.05,1309.04 108.990098,1308.1 108.990098,1306.97 L108.990098,1305.24 C109,1304.23 108.24,1303.38 107.23,1303.26 Z"
        transform="translate(-88 -1288)"
      />
    </Icon>
  );
};
